import { MODULES } from '@/constants/modules'
import { useUserStore } from '@/stores/UserStore'

const orderSelectionRules = [
  { value: 'best_fit_sequence', label: 'Best fit' },
  { value: 'minimum_cost', label: 'Lowest value' },
  // Hiding might have use in the future but for now it's hidden SA-1948 {value: 'largest_first', label: 'Largest first'},
  //  Hiding might have use in the future but for now it's hidden SA-1948 {value: 'minimum_cost_largest_first', label: 'Minimum overall cost and largest first'},
]

export default function packagingSelectionRules() {
  const userStore = useUserStore()

  return orderSelectionRules.filter((rule) => {
    return (
      rule.value !== 'minimum_cost' ||
      userStore.hasEnabledModule(MODULES.VALUATION)
    )
  })
}
